// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05ca8565","453":"fc7ae616","732":"8a426678","977":"996119a6"}[chunkId] + ".chunk.js";
};